import { InjectionToken, Provider } from "@angular/core";
import PeakAuth from "peakauth";
import { environment } from "src/environments/environment";

export const AuthToken = new InjectionToken("PeakAuth");
export const AuthProvider: Provider = {
    provide: AuthToken,
    useValue: new PeakAuth(environment.authBaseUri, "", environment.apiUri)
};
